import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'pharmacy', en);

const RoleListConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Pharmacy',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.PHARMACY,
  permission: PERMISSION.READ,
  routes: [
    {
      path: '/pharmacy/list',
      component: React.lazy(() => import('./PharmacyList')),
    },
  ],
};

export default RoleListConfig;
